import { localStorage } from '../../../database'
import { CountryCode } from '../../../i18n/countryCodes'
import { IStore } from '../../index'

export function getSelectedLanguage(state: IStore): CountryCode {
  const isUser = state.userAccount.user
  if (isUser) {
    const { savedLanguage } = state.userAccount.user
    if (savedLanguage) {
      return savedLanguage
    }
  }

  return localStorage.Driver.getItem(
    localStorage.Names.UserAccountStorage.SelectedLanguage,
    'en',
  ) as CountryCode
}
